import React from "react"
import { withRouter } from "react-router-dom"
import ChooseTimeslotItem from "./choose_time_slot_item";
import { railsToJsTimezoneMap } from "../../util/timezone_utils";
import { formatDatetime } from "../../util/date_util";
import BookingCalendar from "./booking_calendar";

class ChooseTimeModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selected: new Date(),
      selectedTime: "",
      dates: [],
      month: new Date(),
      currentDay: new Date(),
      confirmModal: false,
      isLargeScreen: typeof window === 'undefined' ? true : window.innerWidth > 750,
    }
    this.handler = this.handler.bind(this)
    this.applyTime = this.applyTime.bind(this)
    this.addMonth = this.addMonth.bind(this)
    this.subtractMonth = this.subtractMonth.bind(this)
    this.addDays = this.addDays.bind(this)
    this.subtractDays = this.subtractDays.bind(this)
    this.handleTimeSelect = this.handleTimeSelect.bind(this)
    this.updatePredicate = this.updatePredicate.bind(this)
    this.modalContentRef = React.createRef()
  }

  componentDidMount() {
    document.body.style.overflow = 'hidden';
    this.updatePredicate();
    window.addEventListener("resize", this.updatePredicate);

    let today_date = new Date()
    today_date.setDate(today_date.getDate() + 1)
    
    let previous_time_selected = ""

    if (this.props.contractorTimeSearch){
      previous_time_selected = parseInt(this.props.contractorTimeSearch)
    }

    if (this.props.contractorDateSearch) {
      today_date = new Date(this.props.contractorDateSearch)
      today_date.setHours(0, 0, 0, 0)
    }

    let dates = this.getDaysInMonth(today_date)
    let firstSelectable = this.props.contractorDateSearch ? today_date : this.getFirstSelectableDate(dates)

    this.setState({
      dates: dates,
      currentDay: firstSelectable,
      selected: firstSelectable,
      selectedTime: previous_time_selected,
      month: today_date
    })
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updatePredicate);
    document.body.style.overflow = 'unset';
  }

  updatePredicate() {
    this.setState({ isLargeScreen: window.innerWidth > 550 });
  }

  addDays() {
    let currentDay = new Date(this.state.currentDay)

    if (this.state.isLargeScreen) {
      currentDay.setDate(currentDay.getDate() + 10)
    } else {
      currentDay.setDate(currentDay.getDate() + 5)
    }

    if (currentDay.getMonth() !== this.state.currentDay.getMonth()) {
      currentDay.setDate(1)
    }

    let dates = this.getDaysInMonth(currentDay)
    let firstSelectable = this.getFirstSelectableDate(dates)
    this.setState({ dates: dates, currentDay: firstSelectable, month: currentDay, selected: firstSelectable, selectedTime: "" })
  }

  subtractDays() {
    let currentDay = new Date(this.state.currentDay)

    if (this.state.isLargeScreen) {
      if (currentDay.getDate() < 11 && currentDay.getDate() != 1) {
        currentDay.setDate(1)
      } else {
        currentDay.setDate(currentDay.getDate() - 10)
      }
    } else {
      if (currentDay.getDate() < 6 && currentDay.getDate() != 1) {
        currentDay.setDate(1)
      } else {
        currentDay.setDate(currentDay.getDate() - 5)
      }
    }

    let todayDate = new Date()

    todayDate.setDate(todayDate.getDate() + 1)

    if (currentDay < todayDate && !this.props.currentUser?.roles?.admin) {
      let dates = this.getDaysInMonth(todayDate)
      let firstSelectable = this.getFirstSelectableDate(dates)
      this.setState({ dates: dates, currentDay: firstSelectable, month: todayDate, selected: firstSelectable, selectedTime: "" })
    } else {
      let dates = this.getDaysInMonth(currentDay)
      let firstSelectable = this.getFirstSelectableDate(dates)
      this.setState({ dates: dates, currentDay: firstSelectable, month: currentDay, selected: firstSelectable, selectedTime: "" })
    }
  }

  applyTime() {
    if (this.state.selectedTime !== "") {
      if (this.props.rescheduleModal){
        this.props.changeParentState({ chooseTimeModalOpen: false, contractorDateSearch: new Date(this.state.selected.toLocaleString('en-US', { timeZone: railsToJsTimezoneMap[this.props.detected_timezone] })), contractorTimeSearch: this.state.selectedTime })
      } else {
      let newStateAppointments = this.props.appointments
      let newState = this.props.package_attributes
      delete newStateAppointments[this.props.selectedService]
      if (newState[this.props.selectedService] && newState[this.props.selectedService]["appointment_time"]){
        delete newState[this.props.selectedService]["appointment_time"]
      }
      if (newState[this.props.selectedService] && newState[this.props.selectedService]["contractor_id"]){
        delete newState[this.props.selectedService]["contractor_id"]
      }

        this.props.changeParentState({ appointments: newStateAppointments, package_attributes: newState, chooseTimeModalOpen: false, contractorDateSearch: new Date(this.state.selected.toLocaleString('en-US', { timeZone: railsToJsTimezoneMap[this.props.detected_timezone] })), contractorTimeSearch: this.state.selectedTime})
      }
    }
  }

  addMonth() {
    let date = new Date(this.state.month.getFullYear(), this.state.month.getMonth() + 1, 1)

    let dates = this.getDaysInMonth(date)
    let firstSelectable = this.getFirstSelectableDate(dates)
    this.setState({ dates: dates, month: date, currentDay: firstSelectable, selected: firstSelectable, selectedTime: "" })
  }

  subtractMonth() {
    let today_date = new Date()
    let date = new Date(this.state.month.getFullYear(), this.state.month.getMonth(), 1)

    if (date.getMonth() != today_date.getMonth() || this.props.currentUser?.roles?.admin) {
      date = new Date(this.state.month.getFullYear(), this.state.month.getMonth() - 1, 1)
    }

    let dates = this.getDaysInMonth(date)
    let firstSelectable = this.getFirstSelectableDate(dates)
    this.setState({ dates: dates, month: date, currentDay: firstSelectable, selected: firstSelectable, selectedTime: "" })
  }

  getDaysInMonth(date) {
    let month = date.getMonth()
    let year = date.getFullYear()
    let new_date = new Date(year, month, 1)
    let days = []
    while (new_date.getMonth() === month) {
      days.push(new Date(new_date))
      new_date.setDate(new_date.getDate() + 1)
    }
    return days
  }

  getFirstSelectableDate(dates) {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    return dates.find(d => {
      const normalized = new Date(d)
      normalized.setHours(0, 0, 0, 0)
      return normalized > today
    }) || dates[dates.length - 1]
  }

  changeSelected(index) {
    this.setState({ selected: this.state.dates[index], selectedTime: "" })
  }

  handler(newState) {
    this.setState(newState)
  }

  handleTimeSelect(time) {
    if (this.state.selectedTime === time) {
      this.setState({ selectedTime: "" })
    } else {
      this.setState({ selectedTime: time })
    }
  }


  render() {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const isAdmin = this.props.currentUser?.roles?.admin

    const isCurrentMonth = this.state.month.getMonth() === today.getMonth() &&
                           this.state.month.getFullYear() === today.getFullYear()

    const mostRecentSunday = new Date(today)
    mostRecentSunday.setDate(today.getDate() - today.getDay())
    mostRecentSunday.setHours(0, 0, 0, 0)

    const firstDate = this.state.dates[0]
    // Same rule as before: in the current month, customers don't see weeks
    // that are already over.
    const hidePastWeeks = isCurrentMonth && !isAdmin && firstDate && mostRecentSunday >= firstDate

    const visible = []
    this.state.dates.forEach((date, index) => {
      const normalized = new Date(date)
      normalized.setHours(0, 0, 0, 0)
      if (hidePastWeeks && normalized < mostRecentSunday) return
      visible.push({ date, index, normalized })
    })

    const days = []
    if (visible.length > 0) {
      for (let i = 0; i < visible[0].date.getDay(); i++) days.push({ key: `blank-${i}`, blank: true })
    }
    visible.forEach(({ date, index, normalized }) => {
      const isPast = normalized <= today
      const isSelected = this.state.selected?.toString() === date.toString()
      const clickable = !isPast || isAdmin
      days.push({
        key: `d-${index}`,
        num: date.getDate(),
        selected: isSelected && clickable,
        disabled: !clickable,
        ariaLabel: date.toLocaleString('en-US', { weekday: 'long', month: 'long', day: 'numeric' }),
        onClick: clickable ? () => this.changeSelected(index) : undefined
      })
    })

    let selectedTime = this.state.selectedTime

    let timeSlotOptions = []

    let slots = [8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12, 12.5, 13, 13.5, 14, 14.5, 15, 15.5, 16, 16.5, 17, 17.5, 18, 18.5, 19, 19.5, 20, 20.5]
    let times = ["8:00 am", "8:30 am", "9:00 am", "9:30 am", "10:00 am", "10:30 am", "11:00 am", "11:30 am", "12:00 pm", "12:30 pm", "1:00 pm", "1:30 pm", "2:00 pm", "2:30 pm", "3:00 pm", "3:30 pm", "4:00 pm", "4:30 pm", "5:00 pm", "5:30pm", "6:00 pm", "6:30 pm", "7:00 pm", "7:30pm", "8:00", "8:30"];

    let selectedTimeLabel = ""
    slots.forEach((slot, i) => {
      if (this.props.time_slots[this.state.selected ? this.state.selected.toLocaleString('en-us', { weekday: 'long' }) : new Date().toLocaleString('en-us', { weekday: 'long' })][slot]) {
        if (selectedTime === slot) selectedTimeLabel = times[i]
        timeSlotOptions.push(<ChooseTimeslotItem key={i} currentUser={this.props.currentUser} time={times[i]} slot={slot} selected={selectedTime === slot}
          handleTimeSelect={this.handleTimeSelect} changeParentState={this.handler} />)
      }
    })

    const dayLabel = this.state.selected ? this.state.selected.toLocaleString('en-US', { weekday: 'long', month: 'long', day: 'numeric' }) : ''
    const shortDay = this.state.selected ? this.state.selected.toLocaleString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }) : ''
    const close = () => this.props.changeParentState({ chooseTimeModalOpen: false })

    return <BookingCalendar
      title="Choose your date and time"
      subtitle="Pick a day, then a time."
      onClose={close}
      monthLabel={this.state.month.toLocaleString('en-US', { month: 'long', year: 'numeric' })}
      onPrevMonth={this.subtractMonth}
      onNextMonth={this.addMonth}
      prevDisabled={isCurrentMonth && !isAdmin}
      days={days}
      timesHeading={dayLabel}
      timezoneNote={this.props.detected_timezone ? `Times are shown in ${this.props.detected_timezone}` : null}
      times={timeSlotOptions}
      emptyTimesText="No times for this date"
      summary={shortDay ? `${shortDay} · ${selectedTimeLabel || 'pick a time'}` : 'Choose a date and time'}
      applyLabel="Apply"
      onApply={this.applyTime}
      applyDisabled={this.state.selectedTime === ""}
    />
  }
}

export default withRouter(ChooseTimeModal)